/**
 * Folha "Sugestões": catálogo genérico por categoria. Cada item entra na
 * lista do escopo atual só com um toque; o que já está na lista aparece
 * marcado. Opt-in de verdade: nada entra sozinho.
 */
import { BAGGAGE_CATEGORIES, BAGGAGE_CATEGORY_LABELS, BAGGAGE_SUGGESTIONS, type BaggageCategory, type BaggageScope, normalizeItemTitle } from '@nv/core';
import { useState } from 'react';

import { Icon } from '../../ui/icons';
import { type ItemDaMala, useBagagem } from './store';
import { Sheet } from '../../ui/Sheet';

export function Sugestoes({ escopo, itens, onFechar }: { escopo: BaggageScope; itens: ItemDaMala[]; onFechar: () => void }) {
  const adicionar = useBagagem((s) => s.adicionar);
  const [categoria, setCategoria] = useState<BaggageCategory>('documentos');
  const [ocupado, setOcupado] = useState<string | null>(null);
  const jaTem = new Set(itens.map((i) => normalizeItemTitle(i.title)));

  async function incluir(titulo: string) {
    if (jaTem.has(normalizeItemTitle(titulo))) return;
    setOcupado(titulo);
    try {
      await adicionar({ scope: escopo, titulos: [titulo], category: categoria });
    } finally {
      setOcupado(null);
    }
  }

  return (
    <Sheet titleId="bag-sugestoes" onFechar={onFechar}>
        <h2 className="sheet__title" id="bag-sugestoes">Ideias de mala</h2>
        <p className="sheet__text">Lista genérica, por categoria. Nada entra sozinho: toque no que você quer levar.</p>
        <div className="chip-row" role="tablist" aria-label="Categoria">
          {BAGGAGE_CATEGORIES.map((c) => (
            <button type="button" key={c} role="tab" aria-selected={categoria === c} className={categoria === c ? 'pick pick--on' : 'pick'} onClick={() => setCategoria(c)}>
              {BAGGAGE_CATEGORY_LABELS[c]}
            </button>
          ))}
        </div>
        <ul className="bag__sugestoes" data-testid="bag-sugestoes">
          {BAGGAGE_SUGGESTIONS[categoria].map((titulo) => {
            const tem = jaTem.has(normalizeItemTitle(titulo));
            return (
              <li key={titulo}>
                <button type="button" className={tem ? 'bag__sugestao bag__sugestao--tem' : 'bag__sugestao'} disabled={tem || ocupado === titulo} onClick={() => void incluir(titulo)} data-testid="bag-sugestao">
                  <span className={tem ? 'bag__cx bag__cx--ok' : 'bag__cx'} aria-hidden="true">{tem ? <Icon name="concluir" size={14} /> : <Icon name="criar" size={14} />}</span>
                  <span>{titulo}</span>
                  {tem && <span className="bag__sugestao-ja">já na lista</span>}
                </button>
              </li>
            );
          })}
        </ul>
        <button type="button" className="nv-btn nv-btn--secondary nv-btn--block" onClick={onFechar}>Fechar</button>
    </Sheet>
  );
}
